var ce,
	circleEffect = {
		settings: {
            circlesLayout: $('.block.circles'),
            circlesObjects: $('.block.circles .circle-object'),
            circlesActive: false,
            circlesCreated: [],
            circlesCanvas: $('.block.circles .circle-canvas')
        },

		init: function () {
			ce = this.settings;
            if(ce.circlesLayout.length > 0){
                ce.circlesActive = true;
            }
            ce.circlesObjects.each(function(){
                ce.circlesCreated.push(false);
            });
            // console.log(ce.circlesCreated);
			this.bindUIActions();
			console.log('Circle functionality loaded!');
		},

		bindUIActions: function () {
            $(window).ready(function() {
                circleEffect.onCirScroll();
            });
            $(window).load(function() {
                if(ce.circlesActive){
                    circleEffect.onCirScroll();	
                }
            });
            $(window).scroll(function() {
                if(ce.circlesActive){
                    circleEffect.onCirScroll();	
                }
            });   
		},

        onCirScroll: function() {
            ce.circlesObjects.each(function(i){
                // console.log(circleEffect.elementInViewport($(this)[0]));
                var thisEl = $(this);
                // console.log('circles created array', ce.circlesCreated);
                //console.log(ce.circlesCreated[i] == false);
                if (!ce.circlesCreated[i] && circleEffect.elementInViewport(thisEl[0])) {
                    // console.log('creating circles');
                    Circles.create({
                        id:         thisEl.attr('id'),
                        value:      thisEl.data('value'),
                        radius:     88,
                        width:      16,
                        duration:   1000,
                        colors:     ['#143a69', '#143a69'],
                        text:       thisEl.data('text'),
                    });
                    ce.circlesCreated[i] = true;
                }
            });
        },

        elementInViewport: function(el) {
            var rect = el.getBoundingClientRect();
            return (
                rect.top  >= 0 &&
                rect.left >= 0 &&
                rect.top  <= (window.innerHeight || document.documentElement.clientHeight) - 100
            );
        }        

	};

module.exports = circleEffect;    